<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      
			<el-row class="form-row">
				<el-text style="width:100px; text-align: right;">管理员：</el-text>
				<el-col :span="4">
					<el-input placeholder="请输入管理员" style="width:400px;" v-model="subData.username"></el-input>
				</el-col>
			</el-row>
			<el-row class="form-row">
				<el-text style="width:100px; text-align: right;">密码：</el-text>
				<el-col :span="21" style="overflow:hidden; line-height:30px;">
					<el-input placeholder="请输入密码" style="width:370px; float:left;margin-right:10px;" :type="pwdModel" v-model="subData.password"></el-input>
          <i class="show fa fa-eye" v-if="pwdModel=='text'" @click="hidePwd()"></i>
          <i class="hide fa fa-eye-slash" v-if="pwdModel!='text'" @click="showPwd()"></i>
				</el-col>
			</el-row>
			<el-row class="form-row">
				<el-text style="width:100px; text-align: right;">角色：</el-text>
				<el-col :span="21" style="overflow:hidden; line-height:30px;">
          <el-select v-model="subData.roleId" style="width:400px;" placeholder="请选择">
            <el-option
            v-for="item in roleList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
            </el-option>
					</el-select>   
				</el-col>
			</el-row>
			<el-row class="form-row">
				<el-text style="width:100px; text-align: right;">状态：</el-text>
				<el-col :span="21" style="overflow:hidden; line-height:30px;">
          <el-radio-group v-model="subData.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
				</el-col>
			</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id: '',
      subData:{
				id: '',
        username : '',
				password : '',
        roleId: '',
        state: 1
      },
      showActive: '',
      hideActive: 'active',
      pwdModel: 'password',
      roleList:[],
      stateList:[{
        'id': '0',
        'name':'禁用'
      },{
        'id': '1',
        'name':'启用'
      }]
    }
  },
  mounted:function(){
    this.getRoleList()
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getRoleList(){
      var ths = this
      ths.$get('/Roles/queryAll')
      .then(function (res) { 
          if(res.success){
						ths.roleList = res.data
            if(ths.id){
              ths.getData()
            }
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    getData(){
      var ths = this
      ths.$get('/Admins/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
						ths.subData = res.data
            ths.subData.password = ''
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    showPwd:function(){
        this.showActive = 'active'
        this.hideActive = ''
        this.pwdModel = 'text'
    },
    hidePwd:function(){
        this.showActive = ''
        this.hideActive = 'active'
        this.pwdModel = 'password'
    },
    submitEvent() {
      const ths = this;
      console.log(this.subData)
      if(!this.subData.username || !this.subData.roleId){
        alert("请输入管理员信息");
        return;
      }
      if(!(this.subData.username.length>=6&&this.subData.username.length<=12)){
        alert("用户名长度必须为6-12位");
        return;
      }
      if(this.subData.password && !(this.subData.password.length>=6&&this.subData.password.length<=12)){
        alert("密码长度必须为6-12位");
        return;
      }

      ths.$post('/Admins/edit?', this.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/AdminsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
    },
  }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>